export default function Download() {
  return (
    <section id="download" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl bg-primary-600 px-6 py-12 md:px-12 md:py-16">
          <div className="absolute -right-8 -top-8 h-48 w-48 rounded-full bg-accent-400/30 blur-2xl"></div>
          <div className="absolute -bottom-10 -left-6 h-48 w-48 rounded-full bg-secondary-400/30 blur-2xl"></div>
          <div className="relative z-10 grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <h2 className="font-heading text-3xl text-background-50 md:text-4xl">
                下载动漫之家 APP，追番更自在
              </h2>
              <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-50/90 md:text-base">
                支持 Android 与 iOS，安装后可随时随地追番追漫。若页面未自动识别设备，
                可分别选择下方对应版本下载。
              </p>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <a
                  href="#access"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
                >
                  <i className="ri-android-line text-lg"></i>Android 版
                </a>
                <a
                  href="#access"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-background-100"
                >
                  <i className="ri-apple-line text-lg"></i>iOS 版
                </a>
              </div>
            </div>
            <div className="hidden justify-center lg:flex">
              <div className="flex items-center gap-6 rounded-2xl bg-background-50/15 px-8 py-6 backdrop-blur">
                <div className="text-center">
                  <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-background-50 text-primary-600">
                    <i className="ri-download-cloud-2-line text-3xl"></i>
                  </span>
                  <p className="mt-3 text-sm text-background-50">扫码或点击下载</p>
                </div>
                <div className="h-16 w-px bg-background-50/30"></div>
                <div className="text-center">
                  <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-accent-500 text-background-50">
                    <i className="ri-wifi-line text-3xl"></i>
                  </span>
                  <p className="mt-3 text-sm text-background-50">同步追更记录</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}